export default __webpack_public_path__ + "static/media/toy-robotic-arm@2x.e89ab4a5.png";